// extracted by mini-css-extract-plugin
export default {"wrapperClass":"PNfNbDTmGG95JCxskKgQ"};